import image1 from "../images/dualextract.svg";
import image2 from "../images/fruit1.svg";
import image3 from "../images/fruitbody.svg";
import image4 from "../images/glutenfree.svg";
import image5 from "../images/organic1.svg";
import image6 from "../images/recycle1.svg";
import image7 from "../images/soyfree.svg";
import image8 from "../images/vegan1.svg";

import lionsmane1 from "../images/LionsManeIcon1.svg";
import lionsmane2 from "../images/LionsManeIcon2.svg";
import lionsmane3 from "../images/LionsManeIcon3.svg";
import lionsmane5 from "../images/LionsManeIcon4.svg";
import lionsmane4 from "../images/LionsManeRecycle.svg";
import lionsmane6 from "../images/LionsManeIcone6.svg";
import lionsmane7 from "../images/LionsManeIcone7.svg";
import lionsmane8 from "../images/LionsManeIcone8.svg";

import reishi1 from "../images/Reishi1.svg";
import reishi2 from "../images/Reishi2(1).svg";
import reishi3 from "../images/Reishi3.svg";
import reishi4 from "../images/Reishi4.svg";
import reishi5 from "../images/Reishi5.svg";
import reishi6 from "../images/Reishi6.svg";
import reishi7 from "../images/Reishi7.svg";
import reishi8 from "../images/Reishi8.svg";

export const iconWrapperSuperTroop1 = [
  {
    image: image8,
    subtitle: "Vegan",
  },
  {
    image: image2,
    subtitle: "Natural fruit flavors",
  },
  {
    image: image5,
    subtitle: "Organic",
  },
  {
    image: image3,
    subtitle: "Fruiting body",
  },
];

export const iconWrapperSuperTroop2 = [
  {
    image: image7,
    subtitle: "Soy-free",
  },
  {
    image: image4,
    subtitle: "Gluten-free",
  },
  {
    image: image1,
    subtitle: "Dual extracted",
  },
  {
    image: image6,
    subtitle: "Recyclable",
  },
];

export const iconWrapperLionsMane1 = [
  {
    image: lionsmane1,
    subtitle: "Vegan",
  },
  {
    image: lionsmane6,
    subtitle: "Natural fruit flavors",
  },
  {
    image: lionsmane2,
    subtitle: "Organic",
  },
  {
    image: lionsmane7,
    subtitle: "Fruiting body",
  },
];

export const iconWrapperLionsMane2 = [
  {
    image: lionsmane3,
    subtitle: "Soy-free",
  },
  {
    image: lionsmane8,
    subtitle: "Gluten-free",
  },
  {
    image: lionsmane5,
    subtitle: "Dual extracted",
  },
  {
    image: lionsmane4,
    subtitle: "Recyclable",
  },
];

export const iconWrapperReishi1 = [
  {
    image: reishi1,
    subtitle: "Vegan",
  },
  {
    image: reishi6,
    subtitle: "Natural fruit flavors",
  },
  {
    image: reishi2,
    subtitle: "Organic",
  },
  {
    image: reishi7,
    subtitle: "Fruiting body",
  },
];

export const iconWrapperReishi2 = [
  {
    image: reishi3,
    subtitle: "Soy-free",
  },
  {
    image: reishi8,
    subtitle: "Gluten-free",
  },
  {
    image: reishi5,
    subtitle: "Dual extracted",
  },
  {
    image: reishi4,
    subtitle: "Recyclable",
  },
];
